import React from "react";
import { AdminBackgroundCheckFilesView } from "./view";
import { styles } from "./styles";

export const AdminBackgroundCheckFiles = props => (
  <AdminBackgroundCheckFilesView {...props} styles={styles} />
);
